import { PackagePlus } from 'lucide-react';
import AltaDesdeCodigo from '../gtin/AltaDesdeCodigo';

/* =====================================================================
   Las pantallas del carril `gtin` · Programa Resguardo U-03
   =====================================================================
   Fase a: «Dar de alta desde el código» (DISEÑO-U-03 §6.1). Se abre con el
   código ya puesto desde el 404 de Escanear («Darlo de alta») y desde
   «Códigos que TEGO no reconoció» («Crear un producto con este código»),
   los dos con `irA('gtin-alta', { codigo, … })`.

   VA EN EL MENÚ Y NO OCULTA, y es a propósito: la consola solo abre un
   módulo que el menú enseña (`AppShell` busca en los visibles). Sin código,
   la pantalla lo pide, así que también sirve entrando desde el menú.

   SE ENSEÑA POR EL PERMISO `catalogo`, el mismo que decide si el 404 del
   escáner ofrece el botón y el mismo que exige «Códigos por resolver»: el
   botón y la pantalla aparecen para las mismas personas. Sin `soloEmpresa`
   por la misma razón: el 404 lo ofrece en los dos tipos de cuenta.
   ===================================================================== */
export default {
  orden: 40,
  grupos: [{
    grupo: 'Operación',
    items: [
      { id: 'gtin-alta', etiqueta: 'Dar de alta desde el código', icono: PackagePlus, permiso: 'catalogo', min: 'ENCARGADO', Comp: AltaDesdeCodigo },
    ],
  }],
};
